/**
 * Chatwoot 客服系统 API 端点配置
 */

module.exports = {
    // 获取客服信息
    AGENT_CHATWOOT_INFO: '/system/w/chatwoot/application/api/agent/info',
    // 获取当前商家所有客服
    AGENT_CHATWOOT_AGENTS_LIST: '/system/w/chatwoot/application/api/agent/agents',
    // 获取客服对话列表
    AGENT_CHATWOOT_CONVERSATIONS_LIST: '/system/w/chatwoot/application/api/conversations/list',
    // 获取对话消息列表
    AGENT_CHATWOOT_MESSAGE_LIST: '/system/w/chatwoot/application/api/messages/list',
    // 发送消息
    AGENT_CHATWOOT_MESSAGE_SEND: '/system/w/chatwoot/application/api/messages/send',
    // 发送消息（带文件）
    AGENT_CHATWOOT_MESSAGE_SEND_WITH_FILE: '/system/w/chatwoot/application/api/messages/sendWithFile',
    // 标记会话已读
    AGENT_CHATWOOT_CONVERSATION_MARK_READ: '/system/w/chatwoot/application/api/conversations/markRead',
    // 转接会话
    AGENT_CHATWOOT_CONVERSATION_ASSIGN: '/system/w/chatwoot/application/api/conversations/assign',
    // 获取商家客服渠道列表
    AGENT_CHATWOOT_INBOX_LIST: '/system/w/ChatwootInbox/findList',
}
